// src/App.js
import React from 'react';
import { Web3ReactProvider, useWeb3React } from '@web3-react/core';
import { connectors } from './web3/connectors';
import EventSlider from './components/EventSlider';
import ErrorBoundary from './components/common/ErrorBoundary';
import { SupportChatWidget } from './support';
import './App.css';

function AppInner() {
  const { account } = useWeb3React();
  return (
    <>
      <EventSlider />
      <SupportChatWidget account={account} />
    </>
  );
}

export default function App() {
  return (
    <Web3ReactProvider connectors={connectors}>
      <ErrorBoundary>
        <AppInner />
      </ErrorBoundary>
    </Web3ReactProvider>
  );
}
